import {
  BOAT_ABOUT_STEP,
  BOAT_FIND_STEP,
  BOAT_PRICE_STEP,
} from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Boat";

import { BoatProductDetailsFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Boat/ProductDetails/boatProductDetailsInterfaces";
import { BoatProductIntroFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Boat/ProductIntro/boatProductIntroInterfaces";
import { BoatProductPriceFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/VehicleProducts/Boat/ProductPrice/boatProductPriceInterfaces";
import { BoatType } from "Store/interfaces/products/checkout/riskProducts/BoatProduct";
import { FormState } from "Store/priceCalculation/priceCalculationInterfaces";
import { mapInjuriesToForm } from "Store/priceCalculation/productMappers/common/injuriesMapper";
import { booleanToFormBoolean } from "Utils/formUtils";
import { DEDUCTIBLE_FOUR_THOUSAND } from "Utils/priceUtils";
import { DEFAULT_DEDUCTIBLE_BOAT } from "../boatConstants";

export function mapFromCommerceBoat(data: Record<string, any>): FormState {
  const boatType = data.boatType as BoatType;

  const deductibleCode = String(data.priceSpecifications.deductible.code);

  const boatPriceValues: BoatProductPriceFormValues = {
    deductible: getNewBoatDeductible(boatType, deductibleCode),
    coverage: data.coverageGroup,
  };

  return {
    [BOAT_FIND_STEP.id]: boatFindValues(boatType, data),
    [BOAT_ABOUT_STEP.id]: boatAboutValues(boatType, data),
    [BOAT_PRICE_STEP.id]: boatPriceValues,
  };
}

const getNewBoatDeductible = (
  boatType: BoatType,
  deductibleCode: string,
): string => {
  if (
    boatType === BoatType.SMALL_BOAT ||
    deductibleCode !== DEDUCTIBLE_FOUR_THOUSAND
  ) {
    return deductibleCode;
  }
  return DEFAULT_DEDUCTIBLE_BOAT;
};

const boatFindValues = (
  boatType: BoatType,
  data: Record<string, any>,
): BoatProductIntroFormValues => {
  switch (boatType) {
    case BoatType.MOTOR_BOAT_INBOARDS:
    case BoatType.SAILBOAT:
    case BoatType.MOTOR_BOAT_OUTBOARDS:
      return {
        coverageAmount: data.coverageAmount,
        boatType: data.boatType,
        modelYear: data.modelYear,
        brandAndModel: data.brandAndModel,
        lengthInFeet: data.lengthInFeet,
        engineBrand: data.engineBrand,
        engineHorsePower: data.engineHorsePower,
        engineTopSpeed: data.engineTopSpeed,
        numberOfYearsAsOwner: String(data.numberOfYearsAsOwner),
        boatNotPristine: booleanToFormBoolean(data.boatNotPristine),
      };
    case BoatType.SMALL_BOAT:
      return {
        coverageAmount: data.coverageAmount,
        boatType: data.boatType,
        numberOfYearsAsOwner: String(data.numberOfYearsAsOwner),
      };
  }
};

const boatAboutValues = (
  boatType: BoatType,
  data: Record<string, any>,
): BoatProductDetailsFormValues => {
  switch (boatType) {
    case BoatType.MOTOR_BOAT_INBOARDS:
    case BoatType.SAILBOAT:
    case BoatType.MOTOR_BOAT_OUTBOARDS:
      return {
        hullAndEngineIdMarked: booleanToFormBoolean(data.hullAndEngineIdMarked),
        memberOfRedningsselskapetCoastGuard: booleanToFormBoolean(
          data.memberOfRedningsselskapetCoastGuard,
        ),
        usedByYoungerDriver: booleanToFormBoolean(data.usedByYoungerDriver),
        harbourSecurity: booleanToFormBoolean(data.harbourSecurity),
        trackingSystem: booleanToFormBoolean(data.trackingSystem),
        postNumber: data.harbourZipCode,
        validPostNumber: true,
        city: data.address?.city,
        ...mapInjuriesToForm(
          data.damageCountRecentYears,
          data.yearOfLastDamage,
        ),
      };
    case BoatType.SMALL_BOAT:
      return {
        ...mapInjuriesToForm(
          data.damageCountRecentYears,
          data.yearOfLastDamage,
        ),
      };
  }
};
